import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"

interface MandatoryQuestInfoModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useMandatoryQuestInfoModalStore =
  create<MandatoryQuestInfoModalStoreProps>()((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

export const MandatoryQuestInfoModal = () => {
  const { isOpen, onClose } = useMandatoryQuestInfoModalStore()
  const { t } = useTranslation()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <FlexBox
        direction="column"
        gap={SPACING.space2}
        wrap={false}
        style={{
          padding: `${SPACING.space8} ${SPACING.space4} ${SPACING.space14} ${SPACING.space4}`,
        }}
        fullWidth
      >
        <Typography variant="bodyBold" color={JoonUIColor.text.primary}>
          {t("QUEST_MANDATORY_INFO_TITLE")}
        </Typography>
        <Typography variant="bodySmall" color={JoonUIColor.text.primary}>
          {t("QUEST_MANDATORY_INFO_1")}
        </Typography>
        <Typography variant="bodySmall" color={JoonUIColor.text.primary}>
          {t("QUEST_MANDATORY_INFO_2")}
        </Typography>
        <Typography variant="bodySmall" color={JoonUIColor.text.primary}>
          {t("QUEST_MANDATORY_INFO_3")}
        </Typography>
      </FlexBox>
    </SlideUpModal>
  )
}
